module.exports = __webpack_public_path__ + "media/your_career_track/insurance-sales-agent-9c863d5c.png";